import styled from 'styled-components';

export const FileInputStyle = styled.div`
   li {
      list-style: none;
      font-size: 14px;
   }

 .file-list{
    align-items: center;
    justify-content: space-between;
    
    .help-block{
        float: right !important;
    }
 }
 
 .popover-gearbox {
    display: inline-block;
    position: relative;
    
    &:hover .message {
      opacity: 1;
      transition: opacity .5s;
    }
    
    .message {
      opacity: 0;
      display: inline-block;
      width: 200px;
      background-color: #4D4C59;
      color: #FFFFFF;
      padding: 10px;
      font-size: 10px;
      border-radius: 4px;
      position: absolute;
      top: 25px;
      transform: translateX(-36%);
      z-index: 3;
    }

    .input-file {
        font-size: 16px;
    }    
 
    span.icon {
        background-color: #43BCCD;
        color: #FFFF;
        width: 17px;
        height: 17px;
        display: inline-block;
        border-radius: 50%;
        text-align: center;
        vertical-align: middle;
        margin-left: 11px;
    }
 }
 
 .message-error-files-upload {
    border-radius: 4px;
    font-family: Poppins, Heltica, Arial, sans-serif;
    background-color: #F53D5F;
    font-size: 1.4em;
    padding: 15px 20px;
    display: flex;
    align-items: center;

    p {
      color: #FFFFFF !important;
      margin: 0 !important;
    }
    
     svg.error {
        width: 35px;
        height: 35px;
        display: inline-block;
        margin-right: 10px;
     }
 }
`;
